<template>
    <label
        :for="id"
        class="d-flex font--16 lh--20 mb-0 position-relative"
        :class="labelClass"
    >
        <input
            :id="id"
            :checked="value"
            :disabled="disabled"
            :name="name"
            class="p-0 opacity--0 position-absolute"
            type="checkbox"
            @change="change"
        />

        <v-icon
            :name="value ? 'checkbox-check' : 'checkbox-empty'"
            :w="22"
            :class="iconColorClass"
            class="mr-8"
        />

        <slot />
    </label>
</template>

<script>
import uniqueId from "lodash/uniqueId"

export default {
    props: {
        name: {
            type: String,
            default: null,
        },

        value: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        theme: {
            type: String,
            default: "light",
        },
    },

    emits: ["update:value"],

    data() {
        return {
            id: uniqueId(),
        }
    },

    computed: {
        labelClass() {
            return {
                "cursor--pointer": !this.disabled,
                "text-dark": !this.disabled && this.theme == "light",
                "cursor--not-allowed text-gray-medium": this.disabled,
            }
        },

        iconColorClass() {
            const textPrimary = this.$css(this.$theme.textPrimary)
            const textPrimaryLight = this.$css(this.$theme.textPrimaryLight)
            const textNegative = this.$css(this.$theme.textNegative)
            const textNegativeLight = this.$css(this.$theme.textOverlay15)

            return {
                [textPrimary]:
                    !this.disabled && this.value && this.theme == "light",
                [textPrimaryLight]:
                    this.disabled && this.value && this.theme == "light",
                [textNegative]:
                    !this.disabled && this.value && this.theme == "inverse",
                [textNegativeLight]:
                    this.disabled && this.value && this.theme == "inverse",

                "cursor--not-allowed": this.disabled,
                "cursor--pointer": !this.disabled,
                "text-gray-medium":
                    !this.value && !["light", "inverse"].includes(this.theme),
                "hover:text-gray-dark":
                    !this.value && !this.disabled && this.theme == "light",
            }
        },
    },

    methods: {
        change(event) {
            this.$emit("update:value", !!event.target.checked)
        },
    },
}
</script>
